module.exports = __webpack_public_path__ + "img/1.a66e9506.png";